import axios from "axios";

export default {
    read: (ctrl) => axios.get("/api/users/read", ctrl && { signal: ctrl.signal }),
    readAll: (ctrl) => axios.get("/api/users/read_all", ctrl && { signal: ctrl.signal }),
    getUsersListContextOptions: (ctrl) => axios.get("/api/users/get_users_list_context_options", ctrl && { signal: ctrl.signal }),
    doUsersListContextAction: (obj, ctrl) => axios.post("/api/users/do_users_list_context_action", obj, ctrl && { signal: ctrl.signal }),
    find: (id, ctrl) => axios.get(`/api/users/find/${id}`, ctrl && { signal: ctrl.signal }),
    delete: (id, ctrl) => axios.get(`/api/users/delete/${id}`, ctrl && { signal: ctrl.signal }),
    update: (obj, ctrl) => axios.post("/api/users/update", obj, ctrl && { signal: ctrl.signal }),
    create: (obj, ctrl) => axios.post("/api/users/create", obj, ctrl && { signal: ctrl.signal }),
    recover: (id, ctrl) => axios.get(`/api/users/recover/${id}`, ctrl && { signal: ctrl.signal }),
    lock: (id, ctrl) => axios.get(`/api/users/lock/${id}`, ctrl && { signal: ctrl.signal }),
    getLatestChangeLogs: (id, ctrl) => axios.get(`/api/users/get_latest_changelogs/${id}`, ctrl && { signal: ctrl.signal }),
    markAsRead: () => axios.get("/api/users/mark_as_read"),
    unlock: (id, ctrl) => axios.get(`/api/users/unlock/${id}`, ctrl && { signal: ctrl.signal }),
    readRecover: (ctrl) => axios.get("/api/users/read_recover", ctrl && { signal: ctrl.signal }),
    myself: (ctrl) => axios.get("/api/users/myself", ctrl && { signal: ctrl.signal }),
    update_myself: (obj, ctrl) => axios.post("/api/users/update_myself", obj, ctrl && { signal: ctrl.signal }),
    change_password_myself: (obj, ctrl) => axios.post("/api/users/change_password_myself", obj, ctrl && { signal: ctrl.signal }),
    enableTOTP: (ctrl) => axios.get("/api/users/enable_totp", ctrl && { signal: ctrl.signal }),
    getUsersListConfig: (ctrl) => axios.get("/api/users/get_users_list_config", ctrl && { signal: ctrl.signal }),
    updateUsersListConfig: (obj) => axios.post("/api/users/update_users_list_config", obj),
};
